import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { useRequest, useDebounce, useBoolean, useControllableValue } from 'ahooks';
import ClickOutside from '@wayz/react-click-outside';
import { useMapGLContext, IconLayer } from '@wayz/react-gl';
import { uniqueId } from '../../utils/uniqueId';
// import MapIcon from '@/assets/undiff/mapIcon.png'
// @ts-expect-error
import altas from '../../assets/images/location.png';
import './reset.css';
import './index.css';
/**
 * 获取查询字符串
 *
 * @param {*} params
 * @return {*}  {string}
 */
function getURLSearch(params) {
    return new URLSearchParams(params).toString();
}
/**
 *  获取  poi
 *
 * @param {*} params
 * @returns {(Promise<Tip[] | undefined>)}
 */
async function getTips(searchUrl, params) {
    try {
        const result = await (await fetch(`${searchUrl ? searchUrl : `https://openapi-api.newayz.com/v1/map/amp/v3/assistant/inputtips`}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
        })).json();
        if ((result === null || result === void 0 ? void 0 : result.status) === '1') {
            return result.tips;
        }
        return [];
    }
    catch (error) {
        alert(error);
        throw error;
    }
}
const ICON_MAPPING = {
    marker: { x: 0, y: 0, width: 64, height: 64, mask: true },
};
const ReactGLGeocoder = ({ searchUrl, 
// showIcon,
searchParameters, searchClassName, style, placeholder, 
// mapIcon,
showClose = true, }) => {
    const { setViewState, map } = useMapGLContext();
    const [tipValue, setTipValue] = useControllableValue();
    const debouncedValue = useDebounce(tipValue, { wait: 500 });
    const [open, { setTrue, setFalse }] = useBoolean(false);
    const [lnglat, setLngLat] = useState();
    const { data: resultTips = [] } = useRequest(() => getTips(searchUrl, Object.assign({ keywords: debouncedValue }, searchParameters ? searchParameters : {})), {
        refreshDeps: [debouncedValue, searchUrl, searchParameters],
    });
    const handleInputChange = useCallback((evt) => {
        const tipValue = evt.target.value;
        setTipValue(tipValue);
    }, [setTipValue]);
    const handleClearInput = useCallback(() => {
        setTipValue('');
        setLngLat(undefined);
    }, [setTipValue]);
    // 选中后移动到指定位置
    const handleSelect = useCallback(({ name, location }) => {
        setTipValue(name);
        const [longitude, latitude] = location.split(',').map(parseFloat);
        // 设置marker位置
        setLngLat([[longitude, latitude]]);
        // 飞到选中地点
        setViewState({ longitude, latitude, zoom: 16 });
    }, [setTipValue, setViewState]);
    return map ? (_jsxs("div", { style: style, className: `searchBox ${searchClassName}`, children: [_jsx(IconLayer, { id: "icon-layer", data: lnglat, visible: lnglat && lnglat.length > 0, pickable: true, iconAtlas: altas, iconMapping: ICON_MAPPING, getIcon: () => 'marker', sizeScale: 1, getPosition: (d) => d, getSize: 32, getColor: [18, 150, 219] }), _jsx(ClickOutside, { onClickOutside: setFalse, className: "click-outside", children: _jsxs("div", { className: "input-wrapper", children: [_jsx("input", { id: "input--tip", type: "input", value: tipValue, placeholder: placeholder ? placeholder : '请输入关键字搜索', onChange: handleInputChange, onFocus: setTrue }), showClose && (_jsx("span", { className: "close-btn", onClick: handleClearInput, children: "\u00D7" }))] }) }), _jsx("ul", { id: "map-gl-sug-result", style: {
                    visibility: resultTips.length > 0 && open ? 'visible' : 'hidden',
                }, children: resultTips.map((item, index) => (_jsxs("li", { className: `map-gl-sug-item`, id: `map-gl-sug-item-${index}`, onClick: handleSelect.bind(undefined, item), 
                    // 解决触摸屏点击事件
                    onTouchStart: handleSelect.bind(undefined, item), children: [_jsx("span", { className: "map-gl-sug-item-name", children: item.name }), _jsx("span", { className: "map-gl-sug-item-district", children: item.district })] }, typeof item.id === 'string' ? item.id : uniqueId('map-gl-sug-item-')))) })] })) : null;
};
export default memo(ReactGLGeocoder);
